module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad-in"
  }, [(_vm.file.url == '') ? _c('el-upload', {
    ref: "uploadFiles",
    staticClass: "col s12",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "action": _vm.action,
      "file-list": _vm.fileList,
      "multiple": false,
      "drag": "",
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-exceed": _vm.onExceed,
      "before-upload": _vm.beforeUpload,
      "data": {
        dir: _vm.savedir,
        scriptError: '504 Errore lato server'
      },
      "headers": {
        'X-Request-ID': this.$teras.name,
        'X-aes': false
      },
      "show-file-list": false
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "yo-valign-center"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "4.8rem"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v("Drop file document here or "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("click to upload")])])])])]) : _vm._e(), _vm._v(" "), (_vm.file.url != '') ? _c('div', {
    staticClass: "col s12",
    staticStyle: {
      "height": "100px",
      "border": "1px dashed lightgrey",
      "margin-bottom": "10px"
    }
  }, [(_vm.file.url != '') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 0 0 0"
    }
  }, [_c('div', {
    staticClass: "col s12 yo-align-right"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "alert"
    },
    on: {
      "click": function($event) {
        _vm.docfile = ''
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 yo-align-center"
  }, [_c('a', {
    staticClass: "yo-button yo-text-s",
    attrs: {
      "href": _vm.previewurl + _vm.file.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")]), _c('br'), _vm._v(_vm._s(_vm.file.name) + "\n         ")])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10a1711e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload.vue
// module id = 597
// module chunks = 2